import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/baseInformation/manageArea';
import waves from '@/directive/waves'; // 水波纹指令

import instrumentAdd from './add';
export default {
  components: {
    instrumentAdd: instrumentAdd
  },
  directives: {
    waves: waves
  },
  props: ['id', 'flagId', 'activeName', 'isInitSearch'],
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        areaName: '',
        areaOrder: '',
        areaAddress: ''
      },
      title: '',
      areaId: '',
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
        this.$emit('refreshTree');
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.areaName = '';
        this.listQuery.areaOrder = '';
        this.listQuery.areaAddress = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.areaId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(areaId) {
      this.areaId = areaId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(areaIds) {
      var _this2 = this;

      if (areaIds.length > 0) {
        this.$confirm('你确定是要删除这些小区名称, 是否继续?', '提示').then(function () {
          fetchDelete(areaIds).then(function (response) {
            _this2.getList();

            _this2.$emit('refreshTree');

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(areaId) {
      var areaIds = [];
      areaIds.push(areaId);
      this.delete(areaIds);
    },
    handleDeletes: function handleDeletes() {
      var areaIds = [];
      this.multipleSelection.forEach(function (row) {
        areaIds.push(row.areaId);
      });
      this.delete(areaIds);
    }
  }
};